import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ADOBE_ANALYTICS_PROVIDER } from './AdobeAnalyticsProvider';
import { AnalyticsEffects } from './AnalyticsEffects';



@NgModule({
  imports: [
    EffectsModule.forFeature([AnalyticsEffects])
  ],
  providers: [
    ADOBE_ANALYTICS_PROVIDER
  ]
})
export class AnalyticsResourceModule {}
